import { render } from "./import-overview.vue?vue&type=template&id=073f5e93"
import script from "./import-overview.vue?vue&type=script&lang=js"
export * from "./import-overview.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\softw\\Documents\\Software\\Projects\\CodeRedLabs\\manila-customer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__